import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
import {
  CustomEnums,
  getCustomEnumName,
} from "../../utilities/src/CustomBlockHelpers";

// Customizable Area Start
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  lateDeliveryList: any[];
  loading: boolean;
  page: number;
  pageSize: number;
  totalCount: number;
  popOverOpened: boolean;
  popOverItemId: string;
  popOverItemStatus: string;
  popOverLeft: number;
  popOverTop: number;
  // Customizable Area End
}

interface SS {
  id: any;
  // Customizable Area Start
  // Customizable Area End
}

export default class LateDeliveryListController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  getLateDeliveryListCallId: string = "";
  updateStatusCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.AccoutLoginSuccess),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      // Customizable Area Start
      // Customizable Area End
    ];

    this.state = {
      // Customizable Area Start
      lateDeliveryList: [],
      loading: false,
      page: 0,
      pageSize: 10,
      totalCount: 0,
      popOverOpened: false,
      popOverItemId: "",
      popOverItemStatus: "",
      popOverLeft: 0,
      popOverTop: 0,
      // Customizable Area End
    };
    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    // Customizable Area End
  }

  async receive(from: string, message: Message) {
    // Customizable Area Start
    runEngine.debugLog("Message Recived", message);

    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(
        getName(MessageEnum.RestAPIResponceDataMessage)
      );

      const responseJson = message.getData(
        getName(MessageEnum.RestAPIResponceSuccessMessage)
      );

      const errorReponse = message.getData(
        getName(MessageEnum.RestAPIResponceErrorMessage)
      );

      if (apiRequestCallId === this.getLateDeliveryListCallId) {
        if (responseJson && !responseJson.errors) {
          this.setState({
            lateDeliveryList: responseJson.data || [],
            totalCount: responseJson.meta?.total_count || 0,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
          this.parseApiErrorResponse(responseJson);
        }
      }

      if (apiRequestCallId === this.updateStatusCallId) {
        if (responseJson && !responseJson.errors) {
          this.getLateDeliveryList();
        } else {
          this.parseApiErrorResponse(responseJson);
        }
      }
    }
    // Customizable Area End
  }

  // Customizable Area Start
  async componentDidMount() {
    this.getLateDeliveryList();
  }

  getLateDeliveryList = () => {
    this.setState({ loading: true });

    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("token"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.getLateDeliveryListCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.LateDeliveryListPage.ApiUrls.getLateDeliveryList
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePageChange = (_event: unknown, newPage: number) => {
    this.setState({ page: newPage });
  };

  handleStatusChange = (id: string, checked: boolean) => {
    const header = {
      "Content-Type": configJSON.validationApiContentType,
      token: localStorage.getItem("token"),
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.updateStatusCallId = requestMessage.messageId;

    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `${configJSON.LateDeliveryListPage.ApiUrls.toggleLateDeliveryStatus}/${id}/toggle_active`
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      "PATCH"
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  createData = (
    id: string,
    name: string,
    hours: number,
    color: string,
    status: string
  ) => {
    return { id, name, hours, color, status };
  };

  handleAddConfig = () => {
    const navigateMsg: Message = new Message(
      getCustomEnumName(CustomEnums.PageContainerNavigateMessage)
    );
    navigateMsg.addData(getName(MessageEnum.NavigationTargetMessage), "AddLateDeliveryConfig");
    navigateMsg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(navigateMsg);
  };

  handleViewConfig = (id: string) => {
    this.setState({ popOverOpened: false });
    this.props.navigation.navigate("ViewLateDeliveryConfig", {
      id: id,
    });
  };

  handleEditConfig = (id: string) => {
    this.setState({ popOverOpened: false });
    this.props.navigation.navigate("EditLateDeliveryConfig", {
      id: id,
    });
  };
  // Customizable Area End
}
